import { CustomTypography } from "../../../../components/CustomTypography/CustomTypography";
import { IconWithBackground } from "../../../../components/IconWithBackground/IconWithBackground";
import { transformDataBadge } from "./data";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import {
  typeOfCardOrBadge,
  useGetAllCardsAndBadgeFleetByEmployee,
} from "../../../../api/badge";
import { getCurrentFleetId } from "../../../../utils/getCurrentFleet";
import { useState } from "react";
import { ModalAddBadge } from "./ModalAddBadge";
import { CustomIconButton } from "../../../../components/CustomIconButton/CustomIconButton";
import { useGetOneEmployee } from "../../../../api/employee";

type Props = {};

export const BadgesCollaborator: React.FC<Props> = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { id = "" } = useParams();
  const userId = parseInt(id);
  
  useGetOneEmployee(getCurrentFleetId(), userId);
  
  const [openModal, setOpenModal] = useState(false);

  // The endpoint /fleets/{fleetId}/badges-card/{X} takes a user.id (URL
  // convention shared with every other fleet/employee endpoint). Passing
  // employee?.id (which is a company_user.id) caused the backend to look
  // up by user_id and 404 silently. Sending userId directly also removes
  // the loading flap: employee?.id ?? userId used to bounce between two
  // different values while useGetOneEmployee was still resolving.
  const { cardsAndBadges } = useGetAllCardsAndBadgeFleetByEmployee(
    getCurrentFleetId(),
    userId
  );
  const badgesForCurrentEmployee = cardsAndBadges.filter(
    (cards) =>
      cards.fleet_card.fleet_card_type.support_type === typeOfCardOrBadge.badge
  );

  const onClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <ModalAddBadge
        opeModal={openModal}
        onCancel={onClose}
        onClose={onClose}
      />
      <div className={classes.container}>
        <div className={classes.containerHeader}>
          <CustomTypography
            isUppercase
            text={t("collaborator.badges", "Badges")}
            variant={"h5"}
            styles={{ containerText: classes.contratTitle }}
          />
          <CustomIconButton
            iconName={"plus"}
            widthIcon={"20px"}
            heightIcon={"20px"}
            onClick={() => setOpenModal(true)}
          />
        </div>
        {transformDataBadge(badgesForCurrentEmployee).map((document, index) => (
          <div className={classes.subContainer} key={index}>
            <div className={classes.subContainer2}>
              <IconWithBackground iconName={document.icoName} />
              <div>
                <CustomTypography
                  text={document.title}
                  isUppercase
                  variant="link"
                  fontWeight={"bold"}
                />
                <CustomTypography text={document.subTitle} variant="link" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
